export const AVIALABLE_LANGUAGES = ['pl', 'en'] as const;

export const DEFAULT_LANGUAGE = 'pl';
export type Language = typeof AVIALABLE_LANGUAGES[number];
